import React from 'react';

import { SimpleIcon } from './icon-utils';

export function FeatureIcon() {
  return (
    <SimpleIcon fill="none" height="18" viewBoxDimensions="0 0 18 18" width="18">
      <path
        d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z"
        fill="#324A52"
      />
      <path
        clipRule="evenodd"
        d="M15.5059 5.93728L7.39835 14.045L2.78394 9.74908L4.05274 8.38619L7.35211 11.4578L14.1893 4.62061L15.5059 5.93728Z"
        fill="white"
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
